import React from 'react'
import Tag from './Tag'
import clsx from 'clsx'
import { TagByBlog } from '~/types/blog'

type TagsProps = {
    className?: string
    tags: TagByBlog[]
}

const Tags = ({ className, tags }: TagsProps) => {
    return (
        <div className={clsx(className, 'flex items-center gap-2', {
            'hidden': !tags.length
        })}>
            {tags.map((tag) => (
                <Tag key={tag.slug} slug={tag.slug} name={tag.name} variables={tag.variables} />
            ))}
        </div>
    )
}

export default Tags
